import { Select, Space } from 'antd'

import { MemberPageItem } from '@eastcoal/api/auth/interface'

import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { MemberSelect } from '@eastcoal/shared/@formily/MemberSelect'

import { ComplaintBanCompanySelectProps } from '../BanCompanySelect/interface'

const defaultOptions = [
  {
    label: '全部',
    value: true
  },
  {
    label: '指定',
    value: false
  }
]

const Component = ({
  disabled,
  value = {},
  onChange
}: ComplaintBanCompanySelectProps) => {
  const handleSelectChange = (prohibitAllCompany: boolean) => {
    onChange?.({ companyList: [], prohibitAllCompany })
  }

  const handleCompanyChange = (companyList?: MemberPageItem[]) => {
    onChange?.({
      ...value,
      companyList
    })
  }

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        allowClear={false}
        disabled={disabled}
        options={defaultOptions}
        value={value.prohibitAllCompany}
        style={{
          flex: '0 0 200px'
        }}
        onChange={handleSelectChange}
      />
      <MemberSelect
        disabled={disabled || value.prohibitAllCompany}
        mode='multiple'
        value={value.companyList}
        onChange={handleCompanyChange as any}
      />
    </Space.Compact>
  )
}

export const ComplaintBanCompanySelect = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
